import styled from 'styled-components';
import theme from 'styles/theme';

export const PropertyNameStyled = styled.span`
  color: ${theme.colors.fontGreen};
`;
